module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pageSuperbowl.elements) ? _c('div', {
    staticClass: "superbowl dexcom"
  }, [_c('hero', {
    attrs: {
      "props": _vm.pageSuperbowl.elements,
      "heroHome": false
    }
  }), _vm._v(" "), _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "inside text-center"
  }, [_c('h1', {
    staticClass: "main-title"
  }, [_vm._v(_vm._s(_vm.pageSuperbowl.elements.title_content.value))]), _vm._v(" "), _c('div', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.pageSuperbowl.elements.main_content.value)
    }
  })])]), _vm._v(" "), (_vm.pageSuperbowl.elements != undefined) ? _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "content-section slider"
  }, [_c('slider', {
    attrs: {
      "props": _vm.sliders
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('contact', {
    attrs: {
      "contactFormInfo": _vm.contactFormInfo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a9d3e1e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/landings/Superbowl.vue
// module id = 1499
// module chunks = 0